import {
  getAll,
  getPage,
  getDetail,
  deleteObj,
  getMyPubAll,
  getMyPubPage,
} from '@/api/noticeinfoserv'

export default {
  state: {
    state_NoticeInfo_GetAllResult: null,
    state_NoticeInfo_GetPageResult: null,
    state_NoticeInfo_GetDetailResult: null,
    state_NoticeInfo_DeleteObjResult: null,
    state_NoticeInfo_GetMyPubAllResult: null,
    state_NoticeInfo_GetMyPubPageResult: null,
  },
  mutations: {
    SET_NOTICEINFO_GETALL_RESULT: (state, rst) => {
      state.state_NoticeInfo_GetAllResult = rst;
    },
    SET_NOTICEINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_NoticeInfo_GetPageResult = rst;
    },
    SET_NOTICEINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_NoticeInfo_GetDetailResult = rst;
    },
    SET_NOTICEINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_NoticeInfo_DeleteObjResult = rst;
    },
    SET_NOTICEINFO_GETMYPUBALL_RESULT: (state, rst) => {
      state.state_NoticeInfo_GetMyPubAllResult = rst;
    },
    SET_NOTICEINFO_GETMYPUBPAGE_RESULT: (state, rst) => {
      state.state_NoticeInfo_GetMyPubPageResult = rst;
    },
  },
  actions: {
    NoticeInfoServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICEINFO_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICEINFO_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeInfoServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICEINFO_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICEINFO_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeInfoServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICEINFO_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICEINFO_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeInfoServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICEINFO_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICEINFO_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeInfoServ_GetMyPubAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPubAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICEINFO_GETMYPUBALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICEINFO_GETMYPUBALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeInfoServ_GetMyPubPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPubPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICEINFO_GETMYPUBPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICEINFO_GETMYPUBPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_NoticeInfo_GetAllResult: state => {
      return state.state_NoticeInfo_GetAllResult;
    },
    get_NoticeInfo_GetPageResult: state => {
      return state.state_NoticeInfo_GetPageResult;
    },
    get_NoticeInfo_GetDetailResult: state => {
      return state.state_NoticeInfo_GetDetailResult;
    },
    get_NoticeInfo_DeleteObjResult: state => {
      return state.state_NoticeInfo_DeleteObjResult;
    },
    get_NoticeInfo_GetMyPubAllResult: state => {
      return state.state_NoticeInfo_GetMyPubAllResult;
    },
    get_NoticeInfo_GetMyPubPageResult: state => {
      return state.state_NoticeInfo_GetMyPubPageResult;
    },
  }
}